import * as types from '../actionTypes/candidate'

export function getCandidate(candidate){
  return{
      type: types.GET_CANDIDATE,
      candidate
  }
}

export function getCandidates(candidates){
  return{
      type: types.GET_CANDIDATES,
      candidates
  }
}

export function getCandidateListItems(candidateListItems) {
  return {
    type: types.GET_CANDIDATE_LIST_ITEMS,
    candidateListItems
  }
}

export function getRejectReason(rejectReason) {
  return {
    type: types.GET_REJECT_REASON,
    rejectReason
  }
}


// WEBPACK FOOTER //
// ./src/actions/candidate.js